import { HttpInterceptorFn } from '@angular/common/http';
import { HttpErrorResponse, HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth/auth.service';
import { catchError, Observable, throwError } from 'rxjs';

export const appInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService); // Use Angular's DI for functional interceptors
  const token = authService.getToken();
  const logged_id = authService.getLoggedId(); // Fetch logged_id from AuthService
  console.log('logged_id', logged_id);
  let clonedRequest : any;
  //check if request is formdata instad of json
  if (req.body instanceof FormData) {
    // append logged_id to formdata
    clonedRequest = token
    ? req.clone({
      setHeaders: {
        authorization: `Bearer ${token}`,
      },
    })
    : req;
    // if request has key logged_id replace it
    if (req.body.has('logged_id')) {
      req.body.delete('logged_id');
    }
    req.body.append('logged_id', String(logged_id));
  } else {    
    clonedRequest = token
      ? req.clone({
          setHeaders: {
            authorization: `Bearer ${token}`,
        },
        body: {
          ...req.body, logged_id
        }
        })
      : req;
  }
    

  return next(clonedRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        authService.logout();
      }
      return throwError(() => error);
    })
  );
};
